import React from 'react';

// Toast notifications disabled
const NotificationPopup: React.FC = () => null;

export default NotificationPopup;
